import alert from 'assets/images/alertebostik.svg';
import alertGrey from 'assets/images/alertGrey.png';
import { defaultStyles } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    error: {
        color: defaultStyles.red,
        padding: '2px 5px',
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        ':before': {
            content: '\'\'',
            display: 'inline-block',
            verticalAlign: 'middle',
            width: '32px',
            height: '32px',
            background: 'transparent url(' + alert + ') center center no-repeat',
            marginRight: '10px',
        }
    },
    label: {
        display: 'inline',
        margin: '0',
        verticalAlign: 'middle',
    },
    reverse: {
        backgroundColor: defaultStyles.red,
        color: defaultStyles.white,
        ':before': {
            background: 'transparent url(' + alertGrey + ') center center no-repeat',
        }
    }
});

export default styles;
